import * as XLSX from 'xlsx';
import { decodeListText, parseDelimitedText } from './customerListImport';

/**
 * Datei -> Kopfzeile + Zeilen fuer den Kundenlisten-Import.
 *
 * CSV/TXT werden als Text gelesen (Kodierung erkannt: UTF-8 fuer den eigenen
 * Export, sonst ISO-8859-1 fuer deutsche Excel-CSVs), Excel
 * ueber SheetJS aus dem ersten Tabellenblatt. PDF laeuft NICHT hierueber,
 * sondern ueber die Gemini-Extraktion (extractCustomerList) — ein PDF hat
 * keine verlaesslichen Spalten.
 */
export const fileToTable = async (
    file: File,
): Promise<{ headers: string[]; rows: string[][] }> => {
    const lower = file.name.toLowerCase();
    if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) {
        const buf = await file.arrayBuffer();
        const wb = XLSX.read(buf, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        if (!sheet) return { headers: [], rows: [] };
        const table: string[][] = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            raw: false,
            defval: '',
        });
        const nonEmpty = table.filter((r) => r.some((c) => String(c).trim() !== ''));
        if (!nonEmpty.length) return { headers: [], rows: [] };
        const [head, ...rest] = nonEmpty;
        return {
            headers: head.map((h) => String(h).trim()),
            rows: rest.map((r) => r.map((c) => String(c).trim())),
        };
    }
    return parseDelimitedText(decodeListText(await file.arrayBuffer()));
};
